"use client"

import { useState } from "react"
import AddRoundedIcon from "@mui/icons-material/AddRounded"
import { Fab, Tooltip, alpha, useTheme } from "@mui/material"
import { QuickOrderDrawer } from "./quick-order-drawer"

// 全局浮窗:单一「快录进单」主按钮,点击打开右侧抽屉(不再 hover 二级菜单,根治 hover 热区 bug)。
// 样式:实色主题蓝 + 一圈克制的呼吸光晕(reduced-motion 关)。主权 docs/todo/18。
export function AppQuickCreate() {
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title="快录进单" placement="left">
        <Fab
          color="primary"
          aria-label="快录进单"
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            right: { xs: 18, md: 28 },
            bottom: { xs: 22, md: 28 },
            zIndex: 1200,
            width: 48, // 比默认 56 小一圈,更精致不占地
            height: 48,
            minHeight: 48,
            borderRadius: "40%", // 柔润圆角方块(比正圆有设计感、又不方)
            // 柔和带主题色投影,真正"浮起来"的层次(非默认生硬灰影)
            boxShadow: `0 12px 28px ${alpha(theme.palette.primary.main, 0.32)}`,
            transition: "transform .2s ease, box-shadow .2s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: `0 16px 34px ${alpha(theme.palette.primary.main, 0.4)}`,
            },
            // 呼吸光晕:柔光环缓扩散淡出(4s,更慢更含蓄),用 ::after 叠加、跟随圆角形状
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              borderRadius: "inherit",
              pointerEvents: "none",
              animation: "bobBreathe 4s ease-out infinite",
            },
            "@keyframes bobBreathe": {
              "0%": { boxShadow: `0 0 0 0 ${alpha(theme.palette.primary.main, 0.4)}` },
              "70%": { boxShadow: `0 0 0 10px ${alpha(theme.palette.primary.main, 0)}` },
              "100%": { boxShadow: `0 0 0 0 ${alpha(theme.palette.primary.main, 0)}` },
            },
            "@media (prefers-reduced-motion: reduce)": { "&::after": { animation: "none" } },
          }}
        >
          <AddRoundedIcon />
        </Fab>
      </Tooltip>
      <QuickOrderDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
